import React from "react";
import { Typography } from "@material-ui/core";
import useStyles from "components/common/Styles";

const PasswordInfo = ({ conditions }) => {
  const classes = useStyles();

  const getValidationClass = (condition) =>
    condition ? classes.validPassword : classes.invalidPassword;

  return (
    <div className={classes.passwordInfoContainer}>
      <Typography variant="body1">
        Password must meet the following criteria:
      </Typography>
      <ul className={classes.passwordInfoList}>
        <li>
          <Typography className={getValidationClass(conditions.length)}>
            Must be between 8 and 20 characters
          </Typography>
        </li>
        <li>
          <Typography className={getValidationClass(conditions.uppercase)}>
            At least one uppercase letter
          </Typography>
        </li>
        <li>
          <Typography className={getValidationClass(conditions.lowercase)}>
            At least one lowercase letter
          </Typography>
        </li>
        <li>
          <Typography className={getValidationClass(conditions.number)}>
            At least one number
          </Typography>
        </li>
        <li>
          <Typography className={getValidationClass(conditions.specialChar)}>
            Must contain at least one special character (@$!%*?#^&)
          </Typography>
        </li>
      </ul>
    </div>
  );
};

export default PasswordInfo;
